import { render } from "./CheckBox.vue?vue&type=template&id=6cc2d472&scoped=true"
import script from "./CheckBox.vue?vue&type=script&lang=js"
export * from "./CheckBox.vue?vue&type=script&lang=js"

import "./CheckBox.vue?vue&type=style&index=0&id=6cc2d472&lang=postcss&scoped=true"

import exportComponent from "/home/jocelino/IGAMES-PS2/panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cc2d472"]])

export default __exports__